import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { ErrorOutlined } from '@mui/icons-material';

const AccessDenied: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
      }}
    >
      <Card sx={{ maxWidth: 400, textAlign: 'center', p: 3 }}>
        <CardContent>
          <ErrorOutlined sx={{ fontSize: 60, color: 'error.main' }} />
          <Typography variant="h5" component="div" sx={{ mt: 2 }}>
            Access Denied
          </Typography>
          <Typography sx={{ mt: 1, color: 'text.secondary' }}>
            You do not have the necessary permissions to view this page.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccessDenied;